import { useEffect } from "react";

interface ToastProps {
  message: string;
  onClose: () => void;
}

export default function Toast({ message, onClose }: ToastProps) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 2400);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return (
    <div className="fixed bottom-6 left-1/2 z-[60] w-[calc(100%-2rem)] max-w-sm -translate-x-1/2">
      <div className="flex items-center gap-2 rounded-lg bg-foreground-900 px-4 py-3 text-sm text-background-50 shadow-none animate-fade-up">
        <i className="ri-checkbox-circle-line text-base text-primary-300"></i>
        <span className="flex-1">{message}</span>
        <button
          type="button"
          onClick={onClose}
          aria-label="关闭提示"
          className="cursor-pointer text-background-300 transition-colors hover:text-background-50"
        >
          <i className="ri-close-line text-base"></i>
        </button>
      </div>
    </div>
  );
}